import { render, staticRenderFns } from "./customPage.vue?vue&type=template&id=833452f4&scoped=true"
import script from "./customPage.vue?vue&type=script&lang=js"
export * from "./customPage.vue?vue&type=script&lang=js"
import style0 from "./customPage.vue?vue&type=style&index=0&id=833452f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833452f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('833452f4')) {
      api.createRecord('833452f4', component.options)
    } else {
      api.reload('833452f4', component.options)
    }
    module.hot.accept("./customPage.vue?vue&type=template&id=833452f4&scoped=true", function () {
      api.rerender('833452f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/customerManage/customPage.vue"
export default component.exports